import React from 'react';
import Header from './header/header';
import HomeComponent from './home/home';
import Solutions from './solutions/solutions';
import Projects from './projects/projects';
import Contacts from './contacts/contacts';
import Blog from './blogs/blogs';
import useHeaderStore from 'src/store/useHeaderStore';
import background1 from 'src/assets/background1.png';
import background2 from 'src/assets/background2.png';
import background3 from 'src/assets/background3.png';
import { Box } from '@mui/material';
import Footer from './footer/footer';
import CustomAlert from './shared/alert';
import CustomModal from './shared/modal';
import ModalOrkestadoc from './shared/modalOrskestadoc';

const MainLayout: React.FC = () => {
  const selectedComponent = useHeaderStore((state) => state.selectedOption);

  const renderComponent = () => {
    switch (selectedComponent) {
      case 'home':
        return <HomeComponent />;
      case 'solutions':
        return <Solutions />;
      case 'projects':
        return <Projects />;
      case 'blog':
        return <Blog />;
      case 'contact':
        return <Contacts />;
      default:
        return <HomeComponent />;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundImage: `
          url(${background1}),
          url(${background2}),
          url(${background3})`,
        backgroundSize: 'cover, cover, cover', // Asegura que todas las imágenes cubran el área
        backgroundPosition: 'center, 50% 50%, 0% 0%', // Posición inicial diferente para cada fondo
        backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
        animation: 'circularMove 8s linear infinite',
        '@keyframes circularMove': {
          '0%': { backgroundPosition: '50% 0%, 30% 30%, 0% 0%' },
          '25%': { backgroundPosition: '100% 50%, 70% 20%, 50% 100%' },
          '50%': { backgroundPosition: '50% 100%, 40% 40%, 100% 50%' },
          '75%': { backgroundPosition: '0% 50%, 20% 60%, 50% 0%' },
          '100%': { backgroundPosition: '50% 0%, 30% 30%, 0% 0%' },
        },
      }}
    >
      <CustomAlert />
      <CustomModal />
      <ModalOrkestadoc />
      <Header />
      <Box sx={{ flex: 1, padding: 2 }}>
        {renderComponent()}
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout;
